import { render, staticRenderFns } from "./NewsAttachment.vue?vue&type=template&id=4c8127e8&scoped=true"
import script from "./NewsAttachment.vue?vue&type=script&lang=js"
export * from "./NewsAttachment.vue?vue&type=script&lang=js"
import style0 from "./NewsAttachment.vue?vue&type=style&index=0&id=4c8127e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8127e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8127e8')) {
      api.createRecord('4c8127e8', component.options)
    } else {
      api.reload('4c8127e8', component.options)
    }
    module.hot.accept("./NewsAttachment.vue?vue&type=template&id=4c8127e8&scoped=true", function () {
      api.rerender('4c8127e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/NewsAttachment.vue"
export default component.exports